import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconVisibilitySvg } from "./IconVisibilitySvg.mjs";
import { IconVisibilityHiddenSvg } from "./IconVisibilityHiddenSvg.mjs";
const IconVisibility = ({ hidden, ...props }) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(
  Box,
  {
    component: hidden ? IconVisibilityHiddenSvg : IconVisibilitySvg,
    ...svgProps
  }
) });
export {
  IconVisibility
};
